"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantSignalCommand = exports.AssistantActionContext = exports.AssistantEntryType = void 0;
var AssistantEntryType;
(function (AssistantEntryType) {
    AssistantEntryType["MESSAGE"] = "message";
    AssistantEntryType["STATUS"] = "status";
    AssistantEntryType["ACTION"] = "action";
})(AssistantEntryType || (exports.AssistantEntryType = AssistantEntryType = {}));
var AssistantActionContext;
(function (AssistantActionContext) {
    AssistantActionContext["TEXT_INSERTION"] = "text_insertion";
    AssistantActionContext["KDB_ATTACHMENT"] = "kdb_attachment";
})(AssistantActionContext || (exports.AssistantActionContext = AssistantActionContext = {}));
var AssistantSignalCommand;
(function (AssistantSignalCommand) {
    AssistantSignalCommand["ADD_ENTRY"] = "add_entry";
    AssistantSignalCommand["PASS_ENTRY"] = "pass_entry";
    AssistantSignalCommand["ATTACH_FILE"] = "attach_file";
    AssistantSignalCommand["ADD_FILE"] = "add_file";
    AssistantSignalCommand["MINIMIZE"] = "minimize";
    AssistantSignalCommand["MAXIMIZE"] = "maximize";
    AssistantSignalCommand["CLEAR_ENTRIES"] = "clear_entries";
    AssistantSignalCommand["SELECT_ENTRY"] = "select_entry";
    AssistantSignalCommand["UPDATE_CONTEXT"] = "update_context";
    AssistantSignalCommand["CLEAR_TIMEOUT"] = "clear_timeout";
    AssistantSignalCommand["OPEN_FILE_PICKER"] = "open_knowledge_picker";
    AssistantSignalCommand["OPEN_FILE_PICKER_CREATE_FORM"] = "open_knowledge_picker_create_form";
})(AssistantSignalCommand || (exports.AssistantSignalCommand = AssistantSignalCommand = {}));
